import {
  Box,
  IconButton,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import EditIcon from 'mdi-react/EditIcon';
import SourceBranchIcon from 'mdi-react/SourceBranchIcon';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { useListChannelsQuery } from 'store/app/entities/OtaSlice';
import { I18n } from 'utils/i18n';

const OtaChannelsPage = () => {
  const navigate = useNavigate();
  const { data, isLoading, isFetching, error } = useListChannelsQuery();
  const channels = useMemo(() => data?.channels || [], [data]);
  const loading = isLoading || isFetching;

  return (
    <Box
      sx={{
        p: 2,
        flex: 1,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ mb: 3 }}>
        <Typography variant="h3">{I18n.t('AdminOtaScene.Channels.title')}</Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            mt: 0.5,
          }}
        >
          {I18n.t('AdminOtaScene.Channels.description')}
        </Typography>
      </Box>

      {error && (
        <Typography color="error" sx={{ mb: 2 }}>
          {I18n.t('AdminOtaScene.loadError')}:{' '}
          {error?.data?.error || error?.message || String(error)}
        </Typography>
      )}

      <TableContainer
        sx={{
          width: 'fit-content',
          maxWidth: '100%',
          opacity: loading ? 0.6 : 1,
        }}
      >
        <Table size="small" sx={{ width: 'auto' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ whiteSpace: 'nowrap' }}>
                {I18n.t('AdminOtaScene.Channels.colName')}
              </TableCell>
              <TableCell align="right" sx={{ whiteSpace: 'nowrap' }}>
                {I18n.t('AdminOtaScene.Channels.colRuntimeLines')}
              </TableCell>
              <TableCell align="right" sx={{ width: 48, px: 1 }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {channels.map(channel => (
              <TableRow key={channel._id} hover>
                <TableCell>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Box
                      sx={{
                        width: 32,
                        height: 32,
                        borderRadius: 1,
                        bgcolor: 'primary.ultraLight',
                        color: 'primary.main',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flex: '0 0 auto',
                      }}
                    >
                      <SvgIcon sx={{ fontSize: 18 }}>
                        <SourceBranchIcon />
                      </SvgIcon>
                    </Box>
                    <Box>
                      <Typography variant="body2" sx={{ fontWeight: 700 }}>
                        {channel.name}
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: 'text.secondary',
                          fontFamily: 'monospace',
                        }}
                      >
                        {channel.defaultBranch}
                      </Typography>
                    </Box>
                  </Box>
                </TableCell>
                <TableCell align="right">
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                    }}
                  >
                    {(channel.runtimeLines || []).length}
                  </Typography>
                </TableCell>
                <TableCell align="right" sx={{ width: 48, px: 1 }}>
                  <IconButton
                    size="small"
                    onClick={() =>
                      navigate(`/home/admin/ota/channels/${encodeURIComponent(channel.name)}`)
                    }
                    title={I18n.t('AdminOtaScene.Channels.edit')}
                    aria-label={I18n.t('AdminOtaScene.Channels.edit')}
                  >
                    <EditIcon size={20} />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {!loading && channels.length === 0 && (
              <TableRow>
                <TableCell colSpan={3}>
                  <Typography
                    variant="body2"
                    sx={{
                      color: 'text.secondary',
                    }}
                  >
                    {I18n.t('AdminOtaScene.Channels.empty')}
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default OtaChannelsPage;
